import {mapActions, mapGetters, mapMutations} from "vuex";
import {validation} from "@/mixins/validation.js";
import {pushFormGtmEvent} from "@/utils/formGtm";

export default {
    name: "availability-notify",
    props: {
        ...validation.props,
        title: {
            type: String,
        },
        errorName: {
            type: Boolean,
            default: false
        },
        errorSurname: {
            type: Boolean,
            default: false
        },
        errorPhone: {
            type: Boolean,
            default: false
        },
        errorEmail: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            name: '',
            secondName: '',
            phone: '',
            email: '',
            nameError: false,
            secondNameError: false,
            emailError: false,
            phoneError: false
        }
    },
    mixins: [validation],
    computed: {
        ...mapGetters({
            notifyProductPayload: 'order/availabilityNotifyProduct',
            feedbackLoading: 'setting/feedbackLoading',
        }),
        notifyProduct() {
            return (this.notifyProductPayload && this.notifyProductPayload.product) || {}
        }
    },
    watch: {
        name() {
            if (this.name.length > 0) {
                this.$refs.loginName.textContent = ''
                this.nameError = false
            }
        },
        secondName() {
            if (this.secondName.length > 0) {
                this.$refs.loginSecondName.textContent = ''
                this.secondNameError = false
            }
        },
        phone() {
            if (this.phone.length > 0) {
                this.$refs.loginPhone.textContent = ''
                this.loginFirstPhoneError = false
            }
        },
        email() {
            if (this.email.length > 0) {
                this.$refs.loginRegEmail.textContent = ''
                this.emailError = false
            }
        },
    },
    methods: {
        ...mapMutations({
            showAvailabilityPopup: 'order/SHOW_AVAILABILITY_NOTIFY_POPUP',
        }),
        ...mapActions({
            sendFeedBack: 'setting/SEND_FEEDBACK'
        }),
        hidePopup() {
            this.showAvailabilityPopup(false)
            document.getElementById('html').classList.remove('hide')
        },
        validationEmail() {
            let error = this.$refs.loginRegEmail
            let email = this.email
            let regex = new RegExp('[a-z0-9]+@[a-z]+\\.[a-z]{2,3}');
            if (error) {
                error.textContent = ''
            }
            if (email.length > 0 && !regex.test(email)) {
                error.append(this.$t('validation.email'));
                this.emailError = true
            }
        },
        send() {
            validation.methods.validation(this.$refs.loginName, this.name, 2)
            validation.methods.validation(this.$refs.loginSecondName, this.secondName, 2)
            validation.methods.validation(this.$refs.loginPhone, this.phone, 19)
            this.validationEmail()

            if (!this.nameError && !this.secondNameError && !this.loginFirstPhoneError && !this.emailError) {
                const product = this.notifyProduct || {}
                const payload = {
                    name: this.name,
                    email: this.email,
                    phone: (this.phone || '').replace(/[^\d]/g, ''),
                    type: 'availability_notify',
                    message: `Інформування про наявність: ${product.title || ''} (id: ${product.id || ''}, slug: ${product.slug || ''})`
                }
                this.sendFeedBack(payload)
                    .then(() => {
                        pushFormGtmEvent('availability_callback_form', {
                            phone_number: payload.phone,
                            email: payload.email,
                        });
                        this.showAvailabilityPopup(false)
                        document.getElementById('html').classList.remove('hide')
                        this.$toasted.success(this.$t('form.send'));
                    })
                    .catch(() => {
                        this.$toasted.error(this.$t('form.sendError'));
                    })
            }
        }
    }
}
